// Navbar.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";

import { Box } from "@mui/material";

const Navbar = () => {
    const location = useLocation();

    if (
        location.pathname.startsWith("/cje") ||
        location.pathname.startsWith("/libros") ||
        location.pathname.startsWith("/nodos") ||
        location.pathname.startsWith("/tools")
    )
        return <></>;

    const landing = location.pathname === "/";

    return (
        <Box
            component="header"
            sx={{
                position: landing ? "absolute" : "relative",
                top: 0,
                left: 0,
                width: "100%",
                zIndex: 10,
                color: "#fff",
                background: landing
                    ? "linear-gradient(to bottom, rgba(0,0,0,.45), transparent)"
                    : "#0a0a0a",
            }}
        >
            <Box
                sx={{
                    height: { xs: 72, md: 88 },
                    px: { xs: 3, md: 6 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <Box
                    component={Link}
                    to="/"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        color: "inherit",
                        textDecoration: "none",
                    }}
                >
                    <Box
                        component="img"
                        src="/images/logo-cuervo.svg"
                        alt=""
                        sx={{
                            width: { xs: 30, md: 36 },
                            filter: "invert(1)",
                        }}
                    />

                    <Box
                        component="span"
                        sx={{
                            fontSize: ".8rem",
                            fontWeight: 600,
                            letterSpacing: ".16em",
                        }}
                    >
                        ALEJANDRO LODA
                    </Box>
                </Box>

                <Box
                    component={Link}
                    to="/magia"
                    sx={{
                        position: "relative",
                        color: "inherit",
                        textDecoration: "none",
                        fontSize: ".75rem",
                        letterSpacing: ".18em",
                        opacity: location.pathname === "/magia" ? 1 : 0.7,
                        transition: "opacity .2s ease",
                        "&:hover": {
                            opacity: 1,
                        },
                        "&::after": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            bottom: -6,
                            width: location.pathname === "/magia" ? "100%" : 0,
                            height: "1px",
                            background: "#fff",
                            transition: "width .2s ease",
                        },
                    }}
                >
                    MAGIA
                </Box>
            </Box>
        </Box>
    );
};

export default Navbar;
